import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import { IconButton } from '@mui/material';

import type { FC } from 'react';

interface CloseButtonProps {
  onClick(): void;
}

export const CLOSE_BUTTON_TEST_ID = 'close-button';

export const CloseButton: FC<CloseButtonProps> = ({ onClick }) => (
  <IconButton data-testid={CLOSE_BUTTON_TEST_ID} size="large" onClick={onClick}>
    <CloseOutlinedIcon fontSize="medium" color="action" />
  </IconButton>
);
